import { render } from "./InfoRow.vue?vue&type=template&id=2016a8be&scoped=true"
import script from "./InfoRow.vue?vue&type=script&lang=js"
export * from "./InfoRow.vue?vue&type=script&lang=js"

import "./InfoRow.vue?vue&type=style&index=0&id=2016a8be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2016a8be"]])

export default __exports__